import { useDispatch } from 'react-redux';
import { DispatchProperties, useSelector } from '../../redux/store';
import { TEXT } from '../../shared/Helpers/colors';

import { Text } from '../../shared/uiComponents';
import { hours } from './Helpers/constants';
import { filterByCompleted, filterByDrafts, sortByTime } from './Helpers/functions';
import Session from './Session';
import { parseWallClockTime } from '../../shared/Helpers/timezones';
import { useScreenWidth } from '../../shared/Helpers/hooks';
import { goToNextDay, goToPreviousDay } from '../../redux/State/clientSlice/calendarHelperSlice';
import { useSwipe } from './hooks/useSwipe';

const DayView = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const screenWidth = useScreenWidth();
	const isMobile = screenWidth <= 768;

	const showCompletedSession = useSelector((state) => state.calendarHelper.filterData.showCompleted);
	const showDraftsOnly = useSelector((state) => state.calendarHelper.filterData.showDraftsOnly);
	const events = useSelector((state) => state.calendar.events);
	const day = useSelector((state) => state.calendarHelper.day);
	const month = useSelector((state) => state.calendarHelper.month);

	const swipeHandlers = useSwipe({
		onSwipeLeft: () => {
			if (isMobile) {
				dispatch(goToNextDay());
			}
		},
		onSwipeRight: () => {
			if (isMobile) {
				dispatch(goToPreviousDay());
			}
		},
	});

	return (
		<div className="dayView" {...(isMobile ? swipeHandlers : {})}>
			{hours.map((hour, hourIndex) => (
				<div className="row" key={hourIndex}>
					<div style={{ position: 'relative', minWidth: '80px' }}>
						<Text title={hour} color={TEXT.TERTIARY} type="psm" />
					</div>
					<div style={{ position: 'relative', width: '100%' }}>
						{events &&
							events.length > 0 &&
							[...events]
								.sort((a, b) => sortByTime({ a, b }))
								.filter((x) => (showCompletedSession ? filterByCompleted(x) : true))
								.filter((x) => (showDraftsOnly ? filterByDrafts(x) : true))
								.filter((x) => {
									const start = parseWallClockTime(x.startTime);
									return start.date() === day && start.month() === month && start.hour() === hourIndex + 5;
								})
								.map((res) => <Session key={res.id} event={res} />)}
						<div className="dashedLine" />
					</div>
				</div>
			))}
		</div>
	);
};

export default DayView;
